import { Routes } from '@angular/router';
import { PageNotFoundComponent } from 'ats-platform';

export const ROUTES: Routes = [
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
